package it.neckar.projects.wunschsolar

import it.neckar.projects.common.Port

/**
 * Ports for the Wunschsolar product.
 *
 * Product index 4 in WorktreeDevPorts: slot 10400..10499.
 *   backend = 10000 + 4*100 + 0  = 10400
 *   UI      = 10000 + 4*100 + 10 = 10410
 */
object WunschsolarPorts {
  const val ProductIndex: Int = 4

  val WunschsolarService: Port = Port(10400)

  object Ui {
    val vite: Port = Port(10410)
  }
}
